module.exports = __webpack_public_path__ + "img/icon_job_02.1a623d93.svg";